import api from '../services/api';

export const toWhatsappNumber = (rawPhone, fallback = '+5514935006168') => {
  if (rawPhone == null || String(rawPhone).trim() === '') return null;

  let digits = String(rawPhone).replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('0')) {
    digits = digits.slice(1);
  }

  if (digits.length === 13 && digits.startsWith('55')) {
    return `+${digits}`;
  }
  if (digits.length === 10 || digits.length === 11) {
    return `+55${digits}`;
  }

  return fallback;
};

export const enviarMensagem = async (mensagem) => {
  if (!mensagem.to || !mensagem.text) {
    return { success: false, message: 'Preencha todos os campos' };
  }

  const phoneRegex = /^\+?[1-9]\d{1,14}$/;
  if (!phoneRegex.test(mensagem.to.replace(/\D/g, ''))) {
    return { success: false, message: 'Número de telefone inválido. Use formato: +5511999999999' };
  }

  const payload = {
    to: mensagem.to || '+5514935006168', // fallback se der errado.,
    text: mensagem.text,
    instanceName: 'Prevencor 2700',
    // Parâmetros para o template oficial (Fallback Meta)
    pacienteNome: mensagem.pacienteNome,
    medicoNome: mensagem.medicoNome,
    sala: mensagem.sala,
    templateName: 'chamada_sala', // Nome do template cadastrado na Meta
    languageCode: 'pt_BR',
  };

  try {
    const { data } = await api.post(
      `https://bel-api.moraes-tech.com/api/prevencor/evolution/message`,
      payload
    );

    if (data) {
      const newMsg = {
        id: Date.now(),
        from: 'Você',
        to: mensagem.to,
        text: mensagem.text,
        timestamp: new Date(),
        status: 'sent',
      };
      return {
        success: true,
        message: 'Mensagem enviada com sucesso!',
        data: newMsg,
      };
    } else {
      return { success: false, message: 'Falha ao enviar mensagem.' };
    }
  } catch (error) {
    const msg = 'Erro ao enviar mensagem: ' + error?.message;
    return { success: false, message: msg };
  }
};

export const enviarArquivo = async (payload) => {
  if (!payload.to || !payload.pdfBase64 || !payload.fileName) {
    return {
      success: false,
      message: 'Preencha todos os campos obrigatórios (to, pdfBase64, fileName)',
    };
  }

  const phoneRegex = /^\+?[1-9]\d{1,14}$/;
  if (!phoneRegex.test(payload.to.replace(/\D/g, ''))) {
    return { success: false, message: 'Número de telefone inválido. Use formato: +5511999999999' };
  }

  try {
    const { data } = await api.post(
      'https://bel-api.moraes-tech.com/api/prevencor/evolution/pdf-message',
      {
        to: payload.to,
        pdfBase64: payload.pdfBase64,
        paciente: payload.paciente,
        codLaudo: payload.codLaudo,
        fileName: payload.fileName,
        caption: payload.caption,
      }
    );

    return { success: true, message: data.message, data };
  } catch (error) {
    const msg = 'Erro ao enviar arquivo: ' + (error?.response?.data?.error || error?.message);
    return { success: false, message: msg };
  }
};
